import { use_slice_ui } from '@/hooks/store/use_slices';
import { WatcherSlugPageSearch } from '../_base/watchers/set_workspace_current/WatcherSlugPageSearch';
import { WatcherTranslateTokensFromEnglishSearch } from '../_base/watchers/translate_tokens/WatcherTranslateTokensFromEnglishSearch';
import { WatcherViewEntitySearch } from '../_base/watchers/viewers/WatcherViewEntitySearch';
import { PageSearchViewsDesktop } from './PageSearchViewsDesktop';
import { PageSearchViewsMobile } from './PageSearchViewsMobile';

export function PageSearch() {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  /*
   * EFFECTS
   */

  return (
    <>
      <WatcherSlugPageSearch />
      <WatcherTranslateTokensFromEnglishSearch />
      <WatcherViewEntitySearch />

      {global_is_mobile ? <PageSearchViewsMobile /> : <PageSearchViewsDesktop />}
    </>
  );
}
